export const config = {
  MITSUBISHIWEBCHAT: {
    image: 'img/mitsu/mitsuicon.png',
    primaryColor: '#ce1a26',
    chatIconColor: '#ce1a26',
    minimizeBtnColor: '#FFFFFF',
    serverUrl: 'https://communitybotbyzwizai.herokuapp.com/',
    pageid: '106860078046192',
    projectName: '',
    bgColor: '#ce1a26',
    hasWarroom: false,
    hasLogin: false,
    accessToken: 'Bearer r313p6JWgEUv5Jd87UbxV9Ddos35j7gt',
    clientTextColor: null,
    clientBubbleColor: null,
    hasUploadImage: false
  },
  TRUEIDTEST: {
    logo: 'img/trueid/trueidlogo.png',
    image: 'img/trueid/trueidprofile.png',
    primaryColor: '#000000',
    chatIconColor: '#EC2028',
    minimizeBtnColor: '#000000',
    serverUrl: 'https://communitybotbyzwizai.herokuapp.com/',
    pageid: '109674367070653',
    projectName: '',
    bgColor: '#FFFFFF',
    hasWarroom: true,
    hasLogin: true,
    accessToken: '1357f80e8330b64ae40702kosumida25',
    clientTextColor: '#FFFFFF',
    clientBubbleColor: '#000000',
    hasUploadImage: true
  },
  TRUEID: {
    logo: 'img/trueid/trueidlogo.png',
    image: 'img/trueid/trueidprofile.png',
    primaryColor: '#000000',
    chatIconColor: '#EC2028',
    minimizeBtnColor: '#000000',
    serverUrl: 'https://communitybotbyzwizai.herokuapp.com/',
    pageid: '1858940081055826',
    projectName: '',
    bgColor: '#FFFFFF',
    hasWarroom: true,
    hasLogin: true,
    accessToken: '1357f80e8330b64ae40702kosumida25',
    clientTextColor: '#FFFFFF',
    clientBubbleColor: '#000000',
    hasUploadImage: true
  },
  SPRC: {
    image: 'img/sprc/logo.png',
    primaryColor: '#1d92e1',
    chatIconColor: '#1d92e1',
    minimizeBtnColor: '#000000',
    serverUrl: 'https://api-enterprise.zwiz.app/',
    pageid: '116093288022738',
    projectName: '',
    bgColor: '#1d92e1',
    hasWarroom: false,
    hasLogin: true,
    accessToken: '1357f80e8330b64ae40702kosumida25',
    clientTextColor: null,
    clientBubbleColor: null,
    hasUploadImage: false,
    googleRecaptchaSiteKey: '6Lf3eM0jAAAAAO8bevRXa1X_aXyi8W937THq2x-i'
  },
  DEMO: {
    image: 'img/demo/logo.png',
    primaryColor: '#FCB134',
    chatIconColor: '#FCB134',
    minimizeBtnColor: '#000000',
    serverUrl: 'https://api-enterprise.zwiz.app/',
    pageid: '102901306098188',
    projectName: '',
    bgColor: '#FCB134',
    hasWarroom: false,
    hasLogin: true,
    accessToken: '1357f80e8330b64ae40702kosumida25',
    auth: 'Bearer g2163z5fulgf7a01ksd90afgsjyalaauvwpy3yhn2hf1habu6k24bakdhl9',
    clientTextColor: null,
    clientBubbleColor: null,
    hasUploadImage: false,
    googleRecaptchaSiteKey: '6Lf3eM0jAAAAAO8bevRXa1X_aXyi8W937THq2x-i'
  }
}
